import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import client, { API, apiErr } from "../../lib/api";
import { AiText, Spinner } from "../ui-kit";
import { toast } from "sonner";

const IMG = (u) => API.replace(/\/api$/, "") + u;
export const stamp = (iso) => new Date(iso).toLocaleString(undefined, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function ChartCard({ c, onDelete }) {
  return (
    <article className="surface overflow-hidden" data-testid={`chart-card-${c.id}`}>
      <a href={IMG(c.image_url)} target="_blank" rel="noreferrer"><img src={IMG(c.image_url)} alt={c.title} className="w-full max-h-[420px] object-contain bg-black" /></a>
      <div className="p-4 sm:p-5">
        <div className="flex items-center gap-2 text-[11px] text-slate-500">
          <span className={c.instrument === "BTCUSD" ? "text-btc" : "text-gold"}>{c.instrument}</span>
          <span className="flex items-center gap-1"><Clock size={11} />{stamp(c.created_at)}</span>
          {c.published === false && <span className="text-bear" data-testid={`chart-draft-${c.id}`}>Draft (Telegram)</span>}
          {onDelete && <button data-testid={`chart-delete-${c.id}`} onClick={() => onDelete(c.id)} className="ml-auto text-bear hover:underline">Delete</button>}
        </div>
        <h3 className="font-head text-lg text-white mt-1.5">{c.title}</h3>
        {c.summary && <p className="text-sm text-gold/90 mt-1">{c.summary}</p>}
        <div className="mt-3"><AiText text={c.analysis} /></div>
        <p className="text-[10px] text-slate-600 mt-3">AI analysis of the trader's chart. Not financial advice.</p>
      </div>
    </article>
  );
}

export function ChartFeed() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    client.get("/hub/charts").then(({ data }) => setRows(data)).catch((e) => toast.error(apiErr(e)));
  }, []);
  if (!rows) return <Spinner label="Loading analysis" />;
  if (!rows.length) return <div className="surface p-8 text-center text-sm text-slate-500" data-testid="charts-empty">Abhi koi chart analysis nahi hai.</div>;
  return <div className="grid gap-4 lg:grid-cols-2" data-testid="chart-feed">{rows.map((c) => <ChartCard key={c.id} c={c} />)}</div>;
}
